var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"culture"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_c('div',{staticStyle:{"width":"100%","height":"20px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }